import * as React from "react";
import {FooterPayload, ImageObject} from "../contenful/types";
import './styles/ImageArea.scss';


interface Props {
    footer: FooterPayload;
}

const handleClick = (image: ImageObject) => {
    if(image?.description) {
        let description = image.description;
        if(description && description.includes("http")) {
            window.open(description, "_blank");
        }
    }
}

const ImageArea: React.FC<Props> = ({footer}) => {
    return (
        <div className={"imageAreaContainer"}>
            <div className={"imageArea"}>
            {
                footer.images && footer.images.length > 0 && (
                    footer.images.map((image, index) => {
                        let file = image.file ?? image.fields.file;
                        if(image && file) {

                            return (
                                <div key={index} className={image?.title ? "imageContainer description": "imageContainer"}>
                                    <img alt={image?.title ? image.title : ''}
                                    className={"item"} key={index} onClick={() => handleClick(image)} src={file?.url+"?fm=webp"}
                                    width={file?.details?.image?.width}
                                    height={file?.details?.image?.height}
                                    style={{cursor: `${image.description ? 'pointer' : 'default'}`}}/>
                                </div>
                            )
                        } else {
                            return null
                        }
                    }))
            }
            </div>
        </div>
    )
}

export default ImageArea;

